import Color from '../Color.mjs'
import superMeta from '../_PRODUCT/metaProductNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.GOLD,
    codeProp: 'sfNo',
    detailIdProp: 'sfId',
    detailUrl: '/SfDetail',
    listUrl: '/SfList',
    mapProp: 'sfMap',
    name: '系统功能',
    textProp: 'sfName',
    type: 'SF',
}
